import styles from './PricingMenu.module.css';

export type Plan = {
  id: string;
  name: string;
  price: string;
  type: string;
  features: string[];
  disabled: boolean;
  popular?: boolean;
  comingSoon?: boolean;
};

export default function PricingMenu({
  selectedPlan,
  onSelectPlan,
  plans,
}: {
  selectedPlan: string | null;
  onSelectPlan: (plan: Plan) => void;
  plans?: Plan[];
}) {
  const handlePlanClick = (plan: Plan) => {
    if (!plan.disabled) {
      onSelectPlan(plan);
    }
  };
  const menuPlans: Plan[] = plans ?? [
    {
      id: 'basic',
      name: 'Basic',
      price: '49.99',
      type: 'one-time',
      features: ['Lifetime Access', 'Basic Support', 'Core Features'],
      disabled: false,
    },
    {
      id: 'subscription',
      name: 'Annual Subscription',
      price: '39.99',
      type: 'subscription',
      features: [
        'Yearly Recurring Access',
        'Priority Support',
        'All Features',
        'Automatic Updates',
      ],
      disabled: false,
      popular: true,
    },
    /*{
      id: 'pro',
      name: 'Professional',
      price: '49.99',
      type: 'one-time',
      features: ['Lifetime Access', 'Priority Support', 'Advanced Features', 'API Access'],
      disabled: true,
      comingSoon: true,
    },
    {
      id: 'enterprise',
      name: 'Enterprise',
      price: '99.99',
      type: 'one-time',
      features: [
        'Lifetime Access',
        '24/7 Support',
        'All Features',
        'API Access',
        'Custom Integration',
      ],
      disabled: true,
      comingSoon: true,
    },*/
  ];

  return (
    <div className={styles.pricingMenu}>
      {menuPlans.map(plan => (
        <div
          key={plan.id}
          className={`${styles.plan} ${selectedPlan === plan.id ? styles.selected : ''} ${plan.disabled ? styles.disabled : ''}`}
          onClick={() => handlePlanClick(plan)}
        >
          <h3 className={styles.planName}>
            {plan.name}
            {plan.popular && <span className={styles.popular}>Most Popular</span>}
            {plan.comingSoon && <span className={styles.comingSoon}>Coming Soon</span>}
          </h3>
          <div className={styles.planPrice}>
            <span className={styles.currency}>$</span>
            {plan.price}
            {plan.type === 'subscription' && <span className={styles.period}>/year</span>}
          </div>
          <ul className={styles.features}>
            {plan.features.map((feature, index) => (
              <li key={index} className={styles.feature}>
                <svg
                  className={styles.checkIcon}
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  width="16"
                  height="16"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                {feature}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
